import { NavLink, useLocation, useNavigate } from 'react-router-dom';

import ApplicationLayoutBodyBottomBar from '@rio-cloud/rio-uikit/ApplicationLayoutBodyBottomBar';
import { isMobile } from '@rio-cloud/rio-uikit/DeviceUtils';

import { routes } from '../routes';

type Page = {
    id: string;
    name: string;
    icon: string;
};

type NavItem = {
    key: Page['id'];
    route: JSX.Element;
};

export const BREAKPOINT_MOBILE: number = 480;

export const MOBILE_BOTTOM_BAR_HEIGHT: number = 80;

export const pages: Page[] = [
    {
        id: routes.START,
        name: 'Getting started',
        icon: 'rioglyph rioglyph-home',
    },
    {
        id: routes.FOUNDATIONS,
        name: 'Foundations',
        icon: 'rioglyph rioglyph-design',
    },
    {
        id: routes.COMPONENTS,
        name: 'Components',
        icon: 'rioglyph rioglyph-stack',
    },
    {
        id: routes.TEMPLATES,
        name: 'Templates',
        icon: 'rioglyph rioglyph-cards-grid',
    },
    {
        id: routes.UTILITIES,
        name: 'Utilities',
        icon: 'rioglyph rioglyph-code-brackets',
    },
];

export const navItems: NavItem[] = pages.map(page => ({
    key: page.id,
    route: <NavLink to={`/${page.id}`}>{page.name}</NavLink>,
}));

export const isMobilePortrait = (): boolean => window.innerWidth <= BREAKPOINT_MOBILE;

export const showMobileBottomNavigation: boolean = isMobile() && isMobilePortrait();

export const BottomNavigation = () => {
    const navigate = useNavigate();
    const { pathname } = useLocation();
    const currentPage = pathname.replace('/', '');

    return (
        <ApplicationLayoutBodyBottomBar className='shadow-smooth-to-top padding-0'>
            <div className='display-flex justify-content-between align-items-center width-100pct height-100pct padding-x-20'>
                {pages.map(page => {
                    const isActive = currentPage.startsWith(page.id);
                    return (
                        <div key={page.id} onClick={() => navigate(`/${page.id}`)} className='min-width-50'>
                            <div className='display-flex flex-column align-items-center row-gap-5'>
                                <span
                                    className={`text-size-h3 ${page.icon} ${isActive ? 'text-color-primary' : 'text-color-dark'}`}
                                />
                                <div
                                    className={`${
                                        isActive ? 'text-color-primary' : 'text-color-dark'
                                    } text-size-11 text-center line-height-12`}
                                >
                                    {page.name}
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        </ApplicationLayoutBodyBottomBar>
    );
};
